import { CircularProgress } from "@mui/material";

export const Loading = () => (
  <div
    style={{
      flex: 1,
      display: "flex",
      alignSelf: "center",
      justifyContent: "center",
    }}
  >
    <CircularProgress />
  </div>
);
